export default __webpack_public_path__ + "static/media/2.84ac3187.jpeg";